import type { ElementType, ReactNode } from 'react'
import React, { Fragment } from 'react'

type CellProps<C extends ElementType> = {
  as?: C
  children: ReactNode
}

const Cell = <C extends ElementType>({ as, children, ...props }: CellProps<C>): JSX.Element => {
  const TagName = as || Fragment
  if (TagName !== Fragment) return <TagName {...props}>{children}</TagName>
  return <>{children}</>
}

export default Cell
